import { render, staticRenderFns } from "./categoryComponent.vue?vue&type=template&id=2a2dbdcd&scoped=true"
import script from "./categoryComponent.vue?vue&type=script&lang=js"
export * from "./categoryComponent.vue?vue&type=script&lang=js"
import style0 from "./categoryComponent.vue?vue&type=style&index=0&id=2a2dbdcd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2dbdcd",
  null
  
)

export default component.exports